import { useEffect } from 'react';
import { useThemeStore, getEffectiveTheme } from '../stores/themeStore';

export const ThemeHandler = () => {
    const { theme } = useThemeStore();

    useEffect(() => {
        const applyTheme = () => {
            const root = window.document.documentElement;
            const effectiveTheme = getEffectiveTheme(theme);

            root.classList.remove('light', 'dark');
            root.classList.add(effectiveTheme);
        };

        applyTheme();

        // Listen for system theme changes if mode is 'system'
        if (theme === 'system') {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            const handleChange = () => applyTheme();

            mediaQuery.addEventListener('change', handleChange);
            return () => mediaQuery.removeEventListener('change', handleChange);
        }
    }, [theme]);

    return null;
};
